export enum AdministrationPermissionsPlatform {
  FileUpload = "platform.file.upload",
  OrganizationMetadataManagement = "platform.organization.metadata.management",
  Management = "platform.management",
  TenantUserManagement = "platform.tenant.user.management",
  TenantMetadataManagement = "platform.tenant.metadata.management",
  TenantOrganizationManagement = "platform.tenant.organization.management",
  BaseAccess = "platform.base.access"
}
